<section class="modal-body" [formGroup]="form">
	<div class="modal-header">
		<div>
			<h3 class="fw-bold fs-xs">
				{{
					isPlanMismatch ? 'Divergência de plano' : 'Divergência de carteirinha'
				}}
			</h3>
			<span class="benefit-variant-tag" *ngIf="benefitVariantLabel">
				{{ benefitVariantLabel }}
			</span>
			<p class="fs-xxs gray">
				Escolha qual valor deve ser salvo para a rota de aplicação.
			</p>
		</div>
		<button mat-icon-button type="button" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="modal-content">
		<div class="beneficiary-context" *ngIf="beneficiaryContextLabel">
			<span>Beneficiário</span>
			<strong>{{ beneficiaryContextLabel }}</strong>
		</div>

		<div class="value-choice-list">
			<label
				class="value-choice"
				[class.active]="mode === 'EXTERNAL'"
				for="value-resolution-mode-external"
			>
				<input
					id="value-resolution-mode-external"
					type="radio"
					formControlName="mode"
					value="EXTERNAL"
				/>
				<div class="value-choice__content">
					<span class="value-choice__eyebrow">Base do cliente</span>
					<strong>Usar valor da base do cliente</strong>
					<p class="value-choice__value">{{ currentExternalValue }}</p>
				</div>
			</label>

			<label
				class="value-choice"
				[class.active]="mode === 'DATABASE'"
				for="value-resolution-mode-database"
			>
				<input
					id="value-resolution-mode-database"
					type="radio"
					formControlName="mode"
					value="DATABASE"
				/>
				<div class="value-choice__content">
					<span class="value-choice__eyebrow">Plataforma</span>
					<strong>Manter valor da plataforma</strong>
					<p class="value-choice__value">{{ currentDatabaseValue }}</p>
				</div>
			</label>

			<label
				class="value-choice"
				[class.active]="mode === 'CUSTOM'"
				for="value-resolution-mode-custom"
			>
				<input
					id="value-resolution-mode-custom"
					type="radio"
					formControlName="mode"
					value="CUSTOM"
				/>
				<div class="value-choice__content">
					<span class="value-choice__eyebrow">Manual</span>
					<strong>Informar outro valor</strong>
					<p class="value-choice__description">
						Defina manualmente o valor que deve ser aplicado.
					</p>
				</div>
			</label>
		</div>

		<mat-form-field
			appearance="outline"
			*ngIf="isPlanMismatch && shouldShowCustomField"
		>
			<mat-label>Plano</mat-label>
			<input matInput type="text" formControlName="planName" />
		</mat-form-field>

		<mat-form-field
			appearance="outline"
			*ngIf="isCardMismatch && shouldShowCustomField"
		>
			<mat-label>Carteirinha</mat-label>
			<input matInput type="text" formControlName="cardNumber" />
		</mat-form-field>

		<p class="error-message fs-xxs" *ngIf="errorMessage">
			{{ errorMessage }}
		</p>
	</div>

	<div class="modal-actions">
		<div class="dialog-actions__secondary">
			<button
				mat-stroked-button
				color="primary"
				type="button"
				(click)="onIgnore()"
			>
				Ignorar
			</button>
			<button
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="mode === 'DATABASE'"
				(click)="onApplyOnly()"
			>
				Aplicar somente este
			</button>
		</div>
		<div class="dialog-actions__primary">
			<button mat-flat-button color="primary" type="button" (click)="onSave()">
				Salvar na fila
			</button>
			<button
				mat-button
				color="warn"
				type="button"
				[disabled]="!hasPendingChange"
				(click)="onRemove()"
			>
				Remover da fila
			</button>
		</div>
	</div>
</section>
